import {
  themeCoordColors,
  themeCoordsColorsWithHighOpacity,
} from "../constants/colors";
import { SignatureFlowEnum } from "../constants/signatureFlowEnum";
import { postRequest } from "helpers/axios";
import { API_ROUTES } from "constants/apis";
   
const fetchDocumentDataService = async (reqBody) => {
  try {
    const {
      data: { data },
    } = await postRequest(API_ROUTES.FETCH_DOCUMENT_DATA_API_URL, true, reqBody);

    // const sobjectAPIName = data.sobjectAPIName;
    const signatureFlow = data.signatureFlow;
    let signatoryList = [];

    if (signatureFlow === SignatureFlowEnum.OR) {
      // OR flow: use a single default signer
      const defaultSignatory = {
        id: 0,
        index: 0,
        bgColor: themeCoordColors[0],
        toolColor: themeCoordsColorsWithHighOpacity[0],
        value: 0,
        label: "Signer 1",
      };
      signatoryList.push(defaultSignatory);
    } else if (data.signatoryList != null && data.signatoryList.length > 0) {
      // AND / SEQUENCE / INPERSONSIGNING: map actual signatories
      signatoryList = data.signatoryList.map((signatory, index) => ({
        ...signatory,
        index,
        bgColor: themeCoordColors[index],
        toolColor: themeCoordsColorsWithHighOpacity[index],
        value: signatory.name,
        label: signatory.name,
      }));
    }

    // return { data, signatoryList, sobjectAPIName };
    return { data, signatoryList };
  } catch (error) {
    throw new Error(error.message || "Failed to fetch document data from server.");
  }
};

export default fetchDocumentDataService;
